var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeedHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8607 14.2218C16.7655 14.1266 16.7054 13.9964 16.7054 13.8462L16.7054 8.29654L11.1558 8.29654C10.8653 8.29654 10.6249 8.05613 10.6249 7.76562C10.6249 7.47512 10.8653 7.2347 11.1558 7.2347L17.2363 7.2347C17.5268 7.2347 17.7672 7.47512 17.7672 7.76562L17.7672 13.8462C17.7672 14.1367 17.5268 14.3771 17.2363 14.3771C17.0911 14.3821 16.9558 14.317 16.8607 14.2218Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34588 16.6503C8.14052 16.4449 8.14052 16.1044 8.34588 15.899L16.7755 7.4694C16.9808 7.26404 17.3214 7.26404 17.5268 7.4694C17.7321 7.67476 17.7321 8.01535 17.5268 8.2207L9.09718 16.6503C8.89182 16.8557 8.55123 16.8557 8.34588 16.6503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelp);
export default __webpack_public_path__ + "static/media/need-help.b0017c2f7e7c1f66e5aa4e1f13712a88.svg";
export { ForwardRef as ReactComponent };